import React, { useMemo } from 'react';
import { i18n, useTranslation } from '@lt/localization';

import MultiToggleFilterGroup from '../components/MultiToggleFilterGroup';

const FILTER_LABEL = i18n.t('filters.confirm.filter_label');

const FILTER_NAMES = {
  1: i18n.t('filters.confirm.instant.label'),
  2: i18n.t('filters.confirm.fast.label'),
  3: i18n.t('filters.confirm.all.label'),
};

const FilterConfirmability = ({
  data,
  className,
  onChange,
  isMobile,
  isHotelOnly,
  currencyCode,
}) => {
  const { t } = useTranslation();

  const tourType = isHotelOnly
    ? t('tourType.onlyHotel.plural')
    : t('tourType.withFlights.plural');

  const LABEL_LIST = useMemo(
    () => ({
      1: {
        LABEL: (
          <span>
            {t('filters.confirm.instant.label', {
              title: tourType,
            })}{' '}
          </span>
        ),
        TOOLTIP: t('filters.confirm.instant.tooltip', {
          context: isHotelOnly ? 'hotel' : 'package',
        }),
      },
      2: {
        LABEL: t('filters.confirm.fast.label'),
        TOOLTIP: t('filters.confirm.fast.tooltip', {
          title: tourType,
        }),
      },
      3: {
        LABEL: t('filters.confirm.all.label', {
          title: tourType,
        }),
        TOOLTIP: t('filters.confirm.all.tooltip', {
          context: isHotelOnly ? 'hotel' : 'package',
        }),
      },
    }),
    [tourType, isHotelOnly],
  );

  return (
    <MultiToggleFilterGroup
      className={className}
      filterName="confirmability"
      filterLabel={FILTER_LABEL}
      onChange={onChange}
      isMobile={isMobile}
      data={data}
      labels={LABEL_LIST}
      currencyCode={currencyCode}
    />
  );
};

export default Object.assign(FilterConfirmability, {
  filterName: 'confirmability',
  filterLabel: FILTER_LABEL,
  valuesLabel: (data) => {
    const selectedId = data.find((item) => item.selected)?.id;
    return selectedId ? FILTER_NAMES[selectedId] : undefined;
  },
});
